export const LocalStorageKeys = {
  ONBOARDING: 'onboarding',
  ACCESS_LEVEL: 'accessLevel',
};
